import requests from "./httpService";

const ContactServices = {
  getAllContact: async () => {
    return requests.get(`/contact/`);
  },
  updateContactStatus:async(id,body) =>{
    return requests.put(`/contact/statusUpdate/${id}`, body);
  },
};

export default ContactServices;
